/*
 * SOD custom: cart-waarschuwingen (Base / Alu Cup Cap / cap van de modulaire vazen).
 * Logica 1-op-1 overgenomen uit het live theme (Tinker 3.5.1).
 * Pollt de cart elke seconde; dat overleeft ook de morph-updates
 * van de 4.x cart-drawer zonder aan theme-events te hoeven hangen.
 */
(function () {
  function isKandelaar(title) {
    var t = (title || '').toLowerCase();
    return t.indexOf('kandelaar') !== -1 || t.indexOf('candle holder') !== -1;
  }
  function isBase(title) {
    var t = (title || '').toLowerCase();
    return t.indexOf('base') !== -1 && isKandelaar(title);
  }
  // SOD kerstbal (21-10): met een Halo in de mand is het een kerstbal, geen kandelaar: geen base/cup cap nodig.
  function isHalo(title) {
    var t = (title || '').toLowerCase();
    return t.indexOf('halo') !== -1 && isKandelaar(title);
  }
  function isCupCap(title) {
    var t = (title || '').toLowerCase();
    return t.indexOf('cup cap') !== -1;
  }
  /*
   * Modulaire vazen (XXL / L): of de melding zichtbaar moet zijn rekent het
   * theme zelf uit in snippets/sod-vasecap-warning.liquid (producttype,
   * hoogte-metafield, drempel uit de theme-instellingen). Hier halen we die
   * stand alleen opnieuw op zodra de inhoud van de mand verandert, en zetten
   * we hem elke ronde terug op de blokken in de pagina (overleeft de
   * morph-updates van de cart-drawer).
   */
  var vaseSignature = null;
  var vaseShow = null;
  function applyVaseLines() {
    if (!vaseShow) return;
    document.querySelectorAll('.sod-vasecap-warning').forEach(function (el) {
      el.classList.toggle('visible', vaseShow[el.getAttribute('data-type')] === true);
    });
  }
  function checkVaseLines(items) {
    if (!document.querySelector('.sod-vasecap-warning')) return;
    var signature = items.map(function (i) {
      return i.product_id + 'x' + i.quantity;
    }).join('|');
    if (signature !== vaseSignature) {
      vaseSignature = signature;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      fetch(root + '?section_id=sod-vase-cart-data')
        .then(function (r) {
          if (!r.ok) throw new Error('section ' + r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var show = {};
          doc.querySelectorAll('.sod-vasecap-warning').forEach(function (el) {
            show[el.getAttribute('data-type')] = el.getAttribute('data-show') === 'true';
          });
          vaseShow = show;
          applyVaseLines();
        })
        .catch(function () {
          // Volgende ronde opnieuw proberen.
          vaseSignature = null;
        });
    }
    applyVaseLines();
  }
  function checkCart() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        var hasBase = items.some(function (i) { return isBase(i.product_title || i.title); });
        var hasCupCap = items.some(function (i) { return isCupCap(i.product_title || i.title); });
        var hasShape = items.some(function (i) {
          var t = i.product_title || i.title;
          return isKandelaar(t) && !isBase(t) && !isCupCap(t);
        });
        var hasHalo = items.some(function (i) { return isHalo(i.product_title || i.title); });
        var showBase = hasShape && !hasBase && !hasHalo;
        var showCupCap = hasShape && !hasCupCap && !hasHalo;
        document.querySelectorAll('.sod-base-warning').forEach(function (el) {
          el.classList.toggle('visible', showBase);
        });
        document.querySelectorAll('.sod-cupcap-warning').forEach(function (el) {
          el.classList.toggle('visible', showCupCap);
        });
        checkVaseLines(items);
      });
  }
  setInterval(checkCart, 1000);
})();
